export default __webpack_public_path__ + "static/media/KZ.M.13.2071 black.025c4be2.svg";